import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "admin") {
        toast.error("Not an admin account.");
        return;
      }
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-[#1A1A1A] text-[#FDFBF7] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <p className="font-serif text-3xl tracking-[0.3em] text-center mb-2">DABKAZARI</p>
        <p className="text-[11px] uppercase tracking-nav text-center text-[#BCA37F] mb-10">Atelier Console</p>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-[11px] uppercase tracking-nav text-[#BCA37F]">Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="w-full bg-transparent border-b border-[#BCA37F]/50 focus:border-[#BCA37F] outline-none py-2 text-[#FDFBF7]" data-testid="admin-login-email" />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-nav text-[#BCA37F]">Password</label>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="w-full bg-transparent border-b border-[#BCA37F]/50 focus:border-[#BCA37F] outline-none py-2 text-[#FDFBF7]" data-testid="admin-login-password" />
          </div>
          <button className="w-full py-3 bg-[#BCA37F] text-[#1A1A1A] uppercase tracking-nav text-[11px] hover:bg-[#FDFBF7] transition-colors" disabled={loading} data-testid="admin-login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
